import type { SavedReport, UpdateSavedReportPayload } from '../interfaces';
import type { ApiResponse } from '@Types';
import { API } from '@Providers';

export default async function ({ _id, ...payload }: UpdateSavedReportPayload) {
  const endpoint = `/api/shelter/saved-reports/${_id}`;

  return API({ endpoint, method: 'post', payload }) as Promise<ApiResponse<SavedReport>>;
}
